<template>
  <!-- Majlis's mark, the harness rail (docs/design/majlis-logo): a rail with agents
       plugged in from both sides; the top-centre agent, in the brand red, is the
       team's own. The base is currentColor so it follows the theme's ink; the red
       does not change. The 120-unit grid is cropped to the mark (x10 y18, 100×84);
       the layout keeps the clear space (one agent, 20 units) and the 16px minimum.
       Decorative: the link or the wordmark beside it carries the name. -->
  <svg viewBox="10 18 100 84" aria-hidden="true" focusable="false">
    <rect x="10" y="52" width="100" height="16" fill="currentColor" />
    <g fill="currentColor">
      <rect x="14" y="18" width="20" height="26" />
      <rect x="86" y="18" width="20" height="26" />
      <rect x="14" y="76" width="20" height="26" />
      <rect x="50" y="76" width="20" height="26" />
      <rect x="86" y="76" width="20" height="26" />
    </g>
    <rect class="accent" x="50" y="18" width="20" height="26" />
  </svg>
</template>

<style scoped>
.accent { fill: var(--majlis-red, #ec3013); }
/* A forced palette (Windows contrast themes) keeps explicit SVG fills, so a fixed
   red could vanish or clash there: the mark goes mono, as its mono variant does. */
@media (forced-colors: active) { .accent { fill: currentColor; } }
</style>
